export default class StorageMethods {
  constructor() {}
  cleanSession() {
    localStorage.removeItem("persona");
    localStorage.removeItem("token");
    localStorage.removeItem("admin");
  }
}
